const dataTableData = {
  columns: [
    { Header: "#", accessor: "id", width: "10%" },
    { Header: "المسمى الوظيفي", accessor: "name", width: "70%" },
    { Header: "اجراء", accessor: "actions", width: "20%" },
  ],
  rows: [],
};

export default dataTableData;
